import { cva, VariantProps } from "class-variance-authority";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export interface SigninHeaderProps
    extends VariantProps<typeof SigninHeaderStyles> {
    isPresales: boolean;
    children?: ReactNode;
    className?: string;
}

export const SigninHeaderStyles = cva(
    "flex flex-col items-left justify-center gap-2 lg:mt-10 px-4 max-w-fit md:px-8",
);

export const SigninHeader = ({
    isPresales,
    className,
}: SigninHeaderProps): JSX.Element => {
    const { t } = useTranslation();
    return (
        <div className={twMerge(SigninHeaderStyles({ className }))}>
            <span className="text-ba-accent uppercase tracking-[0.3em] opacity-75 text-sm font-light text-left">
                be•at account
            </span>
            <h1 className="text-2xl lg:text-6xl font-bold text-white text-left mb-0 lg:mb-6">
                {isPresales ? t("campagne.title") : t("regular.title")}
            </h1>
        </div>
    );
};
